import type { Dictionary } from '@/i18n/de'

export const ar: Dictionary = {
    meta: {
        homeDescription: "فيلات فاخرة مع مسبح أو بدونه، ومنازل وشقق لقضاء العطلات في جرجيس وجربة. طلب غير ملزم وخدمة شخصية من تونس.",
        accommodationsTitle: "أماكن الإقامة",
        accommodationsDescription: "فيلات مع مسبح أو بدونه، ومنازل وشقق لقضاء العطلات في جرجيس وجربة. اعثر على مكان إقامتك في تونس.",
        bookingTitle: "طلب حجز",
        bookingDescription: "أرسل إلينا طلب حجز غير ملزم لفيلا أو منزل أو شقة لقضاء العطلة في تونس.",
        contactTitle: "اتصل بنا",
        contactDescription: "تواصل مع URLAUB DE LUXE TUNESIEN في المؤنسة، جرجيس. أسئلة واستشارات وطلبات حجز.",
        loginTitle: "تسجيل الدخول",
        registerTitle: "إنشاء حساب",
        verifyTitle: "تأكيد البريد الإلكتروني",
        forgotTitle: "نسيت كلمة المرور",
        privacyTitle: "الخصوصية",
        imprintTitle: "البيانات القانونية",
        accountTitle: "حسابي"
    },
    common: {
        brandLine: "فيلات وشقق لقضاء العطلات في تونس",
        save: "حفظ",
        saving: "جارٍ الحفظ …",
        cancel: "إلغاء",
        back: "رجوع",
        send: "إرسال",
        sending: "جارٍ الإرسال …",
        close: "إغلاق",
        optional: "اختياري",
        perNight: "لليلة",
        from: "ابتداءً من",
        onRequest: "السعر عند الطلب",
        guestsUpTo: "حتى {count} أشخاص",
        bedrooms: "غرف النوم: {count}",
        bathrooms: "الحمامات: {count}",
        sqm: "{count} م²",
        privatePool: "مسبح خاص",
        withPool: "مع مسبح",
        withoutPool: "بدون مسبح",
        viewDetails: "عرض التفاصيل",
        requestNow: "اطلب الآن",
        download: "تنزيل",
        open: "فتح",
        yes: "نعم",
        no: "لا",
        nightOne: "ليلة واحدة",
        nightOther: "عدد الليالي: {count}",
        adultOne: "بالغ واحد",
        adultOther: "البالغون: {count}",
        childOne: "طفل واحد",
        childOther: "الأطفال: {count}",
        accommodationOne: "مكان إقامة واحد",
        accommodationOther: "أماكن الإقامة: {count}",
        choose: "يرجى الاختيار",
        commonCountries: "الأكثر اختياراً",
        allCountries: "جميع الدول"
    },
    nav: {
        home: "الرئيسية",
        accommodations: "أماكن الإقامة",
        about: "من نحن",
        booking: "طلب حجز",
        contact: "اتصل بنا",
        login: "تسجيل الدخول",
        register: "إنشاء حساب",
        account: "حسابي",
        logout: "تسجيل الخروج",
        openMenu: "فتح القائمة",
        closeMenu: "إغلاق القائمة",
        language: "اختيار اللغة",
        skip: "الانتقال إلى المحتوى"
    },
    types: {
        villa: "فيلا",
        house: "منزل عطلات",
        apartment: "شقة عطلات"
    },
    amenities: {
        pool: "مسبح خاص",
        shared_pool: "مسبح مشترك",
        sea_view: "إطلالة على البحر",
        beach_access: "قريب من الشاطئ",
        wifi: "إنترنت لاسلكي",
        ac: "تكييف هواء",
        heating: "تدفئة",
        kitchen: "مطبخ مجهز بالكامل",
        washing_machine: "غسالة ملابس",
        tv: "تلفاز ذكي",
        parking: "موقف سيارات خاص",
        garden: "حديقة",
        terrace: "شرفة",
        rooftop: "سطح مفتوح",
        courtyard: "فناء داخلي",
        bbq: "شواية",
        housekeeping: "خدمة التنظيف",
        airport_transfer: "نقل من المطار عند الطلب",
        baby_cot: "سرير أطفال عند الطلب",
        elevator: "مصعد"
    },
    home: {
        heroEyebrow: "جرجيس · جربة · تونس",
        heroTitle: "عطلتك الفاخرة في تونس",
        heroText: "فيلات ومنازل وشقق مختارة بعناية على البحر الأبيض المتوسط، مع مسبح خاص أو بدونه. بخدمة شخصية من فريقنا في جرجيس.",
        heroPrimary: "اكتشف أماكن الإقامة",
        heroSecondary: "أرسل طلباً غير ملزم",
        heroImageAlt: "فيلا حديثة بمسبح لا متناهٍ ونخيل وإطلالة على البحر الأبيض المتوسط",
        aboutImageAlt: "منزل تونسي أبيض بباب أزرق",
        searchTitle: "استفسر عن التوفر",
        searchDestination: "الوجهة",
        searchArrival: "الوصول",
        searchDeparture: "المغادرة",
        searchGuests: "الأشخاص",
        searchButton: "ابدأ الطلب",
        anyDestination: "جميع الوجهات",
        highlights: [
            { title: "في جرجيس مباشرة", text: "مقرنا في المؤنسة قرب جرجيس، أي في المكان الذي تقضي فيه عطلتك تماماً." },
            { title: "مختارة بعناية", text: "فيلات ومنازل وشقق في مواقع جميلة قريبة من الشاطئ والمدينة." },
            { title: "طلب غير ملزم", text: "طلبك مجاني، ولا يصبح ملزماً إلا بعد تأكيدنا." },
            { title: "بأربع لغات", text: "الموقع والحساب والرسائل بالألمانية والفرنسية والإنجليزية والعربية." }
        ],
        featuredEyebrow: "أماكن الإقامة لدينا",
        featuredTitle: "فيلات وشقق مختارة",
        featuredText: "من الفيلا ذات المسبح اللامتناهي إلى الشقة القريبة من الشاطئ: اعثر على مكان الإقامة الذي يناسبك.",
        featuredAll: "عرض جميع أماكن الإقامة",
        aboutEyebrow: "من نحن",
        aboutTitle: "في جرجيس نعيش، وبالضيافة نشغف",
        aboutText1: "تقدم URLAUB DE LUXE TUNESIEN فيلات ومنازل وشقق عطلات راقية في جنوب تونس. مقرنا في المؤنسة قرب جرجيس، على بعد دقائق قليلة من شواطئ البحر الأبيض المتوسط.",
        aboutText2: "نقدم لك استشارة شخصية وصادقة لتجد مكان الإقامة المناسب لرحلتك تماماً، ولتمضي عطلتك براحة تامة من أول تواصل حتى المغادرة.",
        aboutPoints: [
            "المقر في المؤنسة، 4144 جرجيس",
            "فيلات مع مسبح وبدونه",
            "منازل وشقق لقضاء العطلات",
            "تواصل شخصي عبر البريد الإلكتروني والحساب"
        ],
        categoriesEyebrow: "لكل الأذواق",
        categoriesTitle: "اعثر على مكان إقامتك",
        categoryPoolTitle: "فيلات مع مسبح",
        categoryPoolText: "خصوصية وشمس ومسبحك الخاص.",
        categoryHouseTitle: "منازل العطلات",
        categoryHouseText: "منازل ساحرة بفناء وحديقة وهدوء تام.",
        categoryApartmentTitle: "شقق العطلات",
        categoryApartmentText: "شقق مريحة قريبة من الشاطئ والمدينة.",
        stepsEyebrow: "بكل بساطة",
        stepsTitle: "عطلة أحلامك في ثلاث خطوات",
        steps: [
            { title: "اختر مكان الإقامة", text: "تصفح فيلاتنا وشققنا أو دع فريقنا يقدم لك الاستشارة." },
            { title: "أرسل طلبك", text: "أخبرنا بتواريخ السفر وعدد الأشخاص ورغباتك. ستحصل على رقم الحجز فوراً." },
            { title: "استلم التأكيد", text: "نتحقق من التوفر ونؤكد حجزك شخصياً عبر البريد الإلكتروني." }
        ],
        destinationsEyebrow: "الوجهات",
        destinationsTitle: "جرجيس وجربة",
        destinations: [
            { name: "جرجيس", text: "شواطئ رملية ناعمة وبساتين زيتون وأجواء هادئة. جرجيس هي المكان المثالي لأيام هادئة على البحر." },
            { name: "جربة", text: "جزيرة البيوت البيضاء والنخيل وسوق حومة السوق النابض بالحياة، يمكن الوصول إليها بسرعة من جرجيس عبر الطريق الروماني." }
        ],
        accountEyebrow: "حسابك",
        accountTitle: "كل شيء في مكان واحد",
        accountText: "مع حسابك الشخصي يمكنك متابعة طلباتك وحجوزاتك ورسائلك ومستنداتك في أي وقت.",
        accountPoints: [
            "حالة طلباتك عبر الإنترنت في أي وقت",
            "الحجوزات المؤكدة والسابقة",
            "تقديم الشكاوى مع الصور",
            "رسائل ومستندات منا"
        ],
        accountRegister: "سجّل مجاناً",
        accountLogin: "تسجيل الدخول",
        ctaTitle: "هل أنت مستعد للشمس والبحر والاسترخاء؟",
        ctaText: "أرسل إلينا طلبك غير الملزم، وسنتواصل معك شخصياً في أقرب وقت ممكن.",
        ctaButton: "اطلب الآن"
    },
    listing: {
        eyebrow: "فيلات · منازل · شقق",
        title: "أماكن الإقامة لدينا",
        intro: "فيلات مع مسبح وبدونه، ومنازل وشقق لقضاء العطلات في جرجيس وجربة.",
        filterType: "النوع",
        filterAll: "الكل",
        filterPool: "المسبح",
        filterPoolAny: "لا يهم",
        filterLocation: "المكان",
        filterLocationAll: "جميع الأماكن",
        filterGuests: "الأشخاص",
        filterGuestsAny: "أي عدد",
        filterApply: "عرض",
        filterReset: "إعادة تعيين",
        empty: "لا يتوفر حالياً مكان إقامة يطابق هذا الاختيار. أرسل إلينا طلباً على أي حال وسيسعدنا تقديم الاستشارة لك.",
        emptyButton: "اطلب استشارة"
    },
    detail: {
        back: "جميع أماكن الإقامة",
        guests: "الأشخاص",
        bedrooms: "غرف النوم",
        bathrooms: "الحمامات",
        size: "المساحة",
        pool: "المسبح",
        poolYes: "خاص",
        poolNo: "لا",
        aboutTitle: "عن مكان الإقامة هذا",
        amenitiesTitle: "المرافق",
        galleryTitle: "صور",
        bookingTitle: "اطلب مكان الإقامة هذا",
        bookingText: "مجاني وغير ملزم. ستحصل على رقم الحجز فوراً.",
        priceNote: "يعتمد السعر النهائي على فترة السفر وعدد الأشخاص.",
        more: "أماكن إقامة أخرى"
    },
    booking: {
        eyebrow: "مجاني وغير ملزم",
        title: "طلب حجز",
        intro: "أخبرنا برغباتك. طلبك غير ملزم، ولا يصبح الحجز نهائياً إلا بعد تأكيدنا.",
        sectionTravel: "رحلتك",
        sectionGuest: "بيانات الاتصال",
        sectionWishes: "الرغبات والرسالة",
        destination: "الوجهة المطلوبة",
        destinationFlexible: "مرن، أرجو تقديم الاستشارة",
        accommodation: "مكان الإقامة المطلوب",
        accommodationAdvice: "لم أقرر بعد، أرجو تقديم الاستشارة",
        arrival: "تاريخ الوصول",
        departure: "تاريخ المغادرة",
        adults: "عدد البالغين",
        children: "عدد الأطفال",
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        nationality: "الجنسية",
        specialRequests: "طلبات خاصة",
        specialRequestsHint: "مثلاً سرير أطفال أو نقل من المطار أو وصول متأخر",
        message: "رسالة إضافية",
        privacyBefore: "لقد قرأت ",
        privacyLink: "سياسة الخصوصية",
        privacyAfter: " وأوافق على معالجة بياناتي لغرض معالجة الطلب.",
        submit: "إرسال الطلب",
        submitting: "جارٍ إرسال الطلب …",
        capacityWarning: "يتسع مكان الإقامة هذا لما يصل إلى {count} أشخاص. يسعدنا اقتراح بدائل مناسبة.",
        loggedInAs: "أنت مسجل الدخول باسم {name}. سيظهر الطلب تلقائياً في حسابك.",
        guestHintBefore: "نصيحة: مع ",
        guestHintLink: "حساب مجاني",
        guestHintAfter: " يمكنك متابعة حالة طلبك عبر الإنترنت في أي وقت.",
        summary: "اختيارك",
        successTitle: "شكراً لطلبك!",
        successText: "لقد استلمنا طلبك. رقم الحجز الخاص بك هو:",
        successEmail: "تم إرسال تأكيد الاستلام إلى {email}. يرجى التحقق من مجلد الرسائل غير المرغوب فيها أيضاً.",
        successNoEmail: "يرجى الاحتفاظ برقم الحجز. سنتواصل معك في أقرب وقت ممكن.",
        successAccount: "إلى طلباتي",
        successNew: "إرسال طلب آخر",
        successHome: "إلى الصفحة الرئيسية"
    },
    auth: {
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        showPassword: "إظهار كلمة المرور",
        hidePassword: "إخفاء كلمة المرور",
        loginTitle: "مرحباً بعودتك",
        loginText: "سجّل الدخول لعرض طلباتك وحجوزاتك ورسائلك.",
        forgot: "نسيت كلمة المرور؟",
        loginButton: "تسجيل الدخول",
        loggingIn: "جارٍ تسجيل الدخول …",
        noAccount: "ليس لديك حساب بعد؟",
        registerLink: "سجّل الآن",
        notVerifiedAction: "تأكيد البريد الإلكتروني الآن",
        registerTitle: "إنشاء حساب",
        registerText: "سجّل مجاناً وأدر طلباتك وحجوزاتك بسهولة عبر الإنترنت.",
        firstName: "الاسم الأول",
        lastName: "اسم العائلة",
        phone: "رقم الهاتف",
        nationality: "الجنسية",
        passwordConfirm: "تأكيد كلمة المرور",
        passwordHint: "8 أحرف على الأقل",
        privacyBefore: "لقد قرأت ",
        privacyLink: "سياسة الخصوصية",
        privacyAfter: " وأوافق على معالجة بياناتي لحسابي.",
        marketing: "نعم، أرغب في تلقي عروض حصرية عبر البريد الإلكتروني من حين لآخر، ويمكنني سحب هذه الموافقة في أي وقت.",
        registerButton: "إنشاء الحساب",
        registering: "جارٍ إنشاء الحساب …",
        haveAccount: "لديك حساب بالفعل؟",
        loginLink: "تسجيل الدخول",
        verifyTitle: "تأكيد البريد الإلكتروني",
        verifyText: "لقد أرسلنا رمز تأكيد مكوناً من 6 أرقام إلى {email}. يرجى إدخاله هنا.",
        verifyTextGeneric: "أدخل بريدك الإلكتروني والرمز المكون من 6 أرقام الموجود في رسالتنا.",
        code: "رمز التأكيد",
        verifyButton: "تأكيد البريد الإلكتروني",
        verifying: "جارٍ التحقق …",
        resend: "إرسال رمز جديد",
        resent: "إذا كان هناك حساب غير مؤكد بهذا العنوان، فإن رمزاً جديداً في الطريق إليك. يرجى التحقق من مجلد الرسائل غير المرغوب فيها أيضاً.",
        verifiedTitle: "تم تأكيد البريد الإلكتروني",
        verifiedText: "شكراً لك! حسابك نشط الآن.",
        emailNotSent: "تم إنشاء حسابك، لكن تعذر إرسال رسالة التأكيد في الوقت الحالي. يرجى طلب رمز جديد أدناه أو المحاولة لاحقاً.",
        forgotTitle: "إعادة تعيين كلمة المرور",
        forgotText: "أدخل بريدك الإلكتروني وسنرسل إليك رمز أمان.",
        sendCode: "إرسال الرمز",
        codeSent: "إذا كان هناك حساب بهذا العنوان، فقد أرسلنا إليك رمزاً. يرجى التحقق من مجلد الرسائل غير المرغوب فيها أيضاً.",
        resetCode: "رمز الأمان",
        newPassword: "كلمة المرور الجديدة",
        resetButton: "حفظ كلمة المرور الجديدة",
        resetDone: "تم تغيير كلمة المرور. يمكنك الآن تسجيل الدخول.",
        backToLogin: "العودة إلى تسجيل الدخول",
        sideTitle: "عطلتك برعاية شخصية",
        sideText: "الطلبات والحجوزات والشكاوى والرسائل في مكان واحد."
    },
    errors: {
        required: "يرجى ملء هذا الحقل.",
        invalid_email: "يرجى إدخال بريد إلكتروني صالح.",
        invalid_phone: "يرجى إدخال رقم هاتف صالح.",
        invalid_country: "يرجى اختيار الجنسية.",
        password_short: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل.",
        password_mismatch: "كلمتا المرور غير متطابقتين.",
        invalid_date: "يرجى اختيار تاريخ صالح.",
        date_past: "لا يمكن أن يكون التاريخ في الماضي.",
        date_order: "يجب أن يكون تاريخ المغادرة بعد تاريخ الوصول.",
        stay_too_long: "لا يمكن أن تتجاوز مدة الإقامة 90 ليلة.",
        invalid_number: "يرجى إدخال عدد صالح.",
        consent_required: "يرجى الموافقة على سياسة الخصوصية.",
        invalid_credentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
        email_not_verified: "يرجى تأكيد بريدك الإلكتروني أولاً.",
        account_blocked: "هذا الحساب محظور. يرجى التواصل معنا.",
        email_taken: "هذا البريد الإلكتروني مسجل بالفعل.",
        code_invalid: "الرمز غير صحيح.",
        code_expired: "انتهت صلاحية الرمز. يرجى طلب رمز جديد.",
        code_locked: "محاولات خاطئة كثيرة. يرجى طلب رمز جديد.",
        rate_limited: "محاولات كثيرة. يرجى الانتظار قليلاً ثم المحاولة مرة أخرى.",
        file_type: "نوع الملف غير مدعوم. يُسمح بالصور وملفات PDF ومستندات Word.",
        file_too_large: "حجم الملفات كبير جداً.",
        too_many_files: "يمكن إرفاق 5 ملفات كحد أقصى.",
        file_invalid: "تعذرت قراءة الملف.",
        upload_failed: "تعذر رفع الملفات. يرجى المحاولة مرة أخرى.",
        not_cancellable: "لم يعد من الممكن إلغاء هذا الطلب أو الحجز.",
        wrong_password: "كلمة المرور غير صحيحة.",
        unauthorized: "يرجى تسجيل الدخول مرة أخرى.",
        network: "لا يوجد اتصال. يرجى التحقق من اتصالك بالإنترنت.",
        server_error: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
        validation: "يرجى التحقق من البيانات المدخلة.",
        not_found: "غير موجود.",
        forbidden: "هذا الإجراء غير مسموح."
    },
    bookingStatus: {
        new: "تم الاستلام",
        in_review: "قيد المعالجة",
        confirmed: "مؤكد",
        declined: "مرفوض",
        cancelled: "ملغى",
        completed: "مكتمل"
    },
    complaintStatus: {
        open: "مفتوحة",
        in_progress: "قيد المعالجة",
        resolved: "تم الحل",
        closed: "مغلقة"
    },
    account: {
        areaTitle: "حسابي",
        customerNumber: "رقم العميل",
        nav: {
            overview: "نظرة عامة",
            profile: "ملفي الشخصي",
            requests: "طلبات الحجز",
            bookings: "حجوزاتي المؤكدة",
            past: "حجوزاتي السابقة",
            cancellations: "إلغاءاتي",
            complaints: "شكاواي",
            messages: "رسائلي",
            documents: "مستنداتي",
            settings: "إعداداتي"
        },
        hello: "مرحباً",
        overviewText: "هنا تجد كل ما يتعلق برحلاتك معنا.",
        statOpenRequests: "طلبات مفتوحة",
        statUpcoming: "رحلات قادمة",
        statComplaints: "شكاوى مفتوحة",
        statMessages: "رسائل جديدة",
        nextTrip: "رحلتك القادمة",
        noTrip: "لا توجد رحلة مؤكدة بعد. ما رأيك ببعض الشمس والبحر؟",
        newRequest: "طلب جديد",
        recentRequests: "أحدث طلباتك",
        noRequests: "لم ترسل أي طلبات بعد.",
        viewAll: "عرض الكل",
        profileText: "بياناتك الشخصية التي نستخدمها لطلباتك وحجوزاتك.",
        emailLocked: "البريد الإلكتروني هو اسم الدخول الخاص بك. لتغييره يرجى مراسلتنا.",
        profileSaved: "تم حفظ بياناتك.",
        memberSince: "مسجل منذ",
        requestsText: "الطلبات التي نعالجها حالياً والطلبات المرفوضة.",
        bookingsText: "إقاماتك المؤكدة القادمة.",
        pastText: "رحلاتك السابقة معنا.",
        cancellationsText: "الطلبات والحجوزات الملغاة.",
        requestsEmpty: "ليس لديك حالياً أي طلبات مفتوحة.",
        bookingsEmpty: "ليس لديك حالياً أي حجوزات مؤكدة.",
        pastEmpty: "ستظهر رحلاتك السابقة هنا.",
        cancellationsEmpty: "ليس لديك أي إلغاءات.",
        requestedOn: "تاريخ الطلب {date}",
        details: "التفاصيل",
        detailTitle: "الحجز",
        timeline: "السجل",
        submitted: "تم استلام الطلب",
        yourDetails: "بياناتك",
        travelDetails: "بيانات الرحلة",
        noteFromUs: "رسالة منا",
        totalPrice: "السعر الإجمالي",
        cancelTitle: "إلغاء",
        cancelText: "هل تريد إلغاء هذا الطلب أو الحجز؟ ستتلقى تأكيداً عبر البريد الإلكتروني.",
        cancelReason: "السبب (اختياري)",
        cancelButton: "إلغاء الطلب أو الحجز",
        cancelConfirm: "نعم، إلغاء الآن",
        cancelDone: "تم حفظ الإلغاء.",
        cancelledByCustomer: "ألغيته أنت",
        cancelledByAdmin: "ألغيناه نحن",
        reportProblem: "الإبلاغ عن مشكلة",
        complaintsText: "قدّم شكوى وتابع حالة معالجتها.",
        newComplaint: "شكوى جديدة",
        complaintsEmpty: "ليس لديك أي شكاوى.",
        complaintSubject: "الموضوع",
        complaintBooking: "الحجز المعني",
        complaintNoBooking: "لا يوجد حجز محدد",
        complaintMessage: "رسالتك",
        complaintMessageHint: "يرجى وصف ما حدث بأكبر قدر ممكن من الدقة.",
        files: "الصور والمستندات",
        filesHint: "حتى 5 ملفات (صور، PDF، Word) بحجم إجمالي أقصاه 10 ميغابايت. يتم تصغير الصور الكبيرة تلقائياً.",
        chooseFiles: "اختيار الملفات",
        removeFile: "إزالة الملف",
        complaintSubmit: "تقديم الشكوى",
        complaintSubmitted: "تم تقديم شكواك رقم {number}.",
        complaintNumber: "رقم الشكوى",
        submittedOn: "تاريخ التقديم",
        attachments: "المرفقات",
        replyLabel: "ردك",
        replyButton: "إرسال الرد",
        replySent: "تم إرسال ردك.",
        you: "أنت",
        closedNote: "هذه الشكوى مغلقة. إذا قمت بالرد فسنعيد فتحها.",
        messagesText: "رسائلك المتبادلة معنا.",
        messagesEmpty: "لا توجد رسائل بعد.",
        newMessage: "كتابة رسالة جديدة",
        messageSubject: "الموضوع",
        messageBody: "الرسالة",
        messageSend: "إرسال الرسالة",
        messageSent: "تم إرسال رسالتك.",
        fromUs: "منا",
        fromYou: "منك",
        documentsText: "المستندات التي وفرناها لك والملفات التي رفعتها.",
        documentsEmpty: "لا توجد مستندات بعد.",
        uploadedByYou: "رفعته أنت",
        providedByUs: "مقدم منا",
        languageTitle: "لغة الرسائل",
        languageText: "نرسل إليك رسائلنا بهذه اللغة.",
        marketingTitle: "العروض عبر البريد الإلكتروني",
        marketingText: "أرغب في تلقي عروض حصرية عبر البريد الإلكتروني من حين لآخر، ويمكنني سحب هذه الموافقة في أي وقت.",
        marketingSince: "تمت الموافقة بتاريخ {date}",
        passwordTitle: "تغيير كلمة المرور",
        currentPassword: "كلمة المرور الحالية",
        newPassword: "كلمة المرور الجديدة",
        confirmPassword: "تأكيد كلمة المرور الجديدة",
        passwordSaved: "تم تغيير كلمة المرور.",
        privacyTitle: "الخصوصية",
        privacyAccepted: "تمت الموافقة على سياسة الخصوصية بتاريخ {date}",
        deleteTitle: "حذف الحساب",
        deleteText: "سيتم حذف حسابك وشكاواك ورسائلك ومستنداتك نهائياً، وستصبح بيانات الحجز مجهولة الهوية. لا يمكن التراجع عن ذلك.",
        deleteButton: "حذف الحساب",
        deletePassword: "يرجى إدخال كلمة المرور للتأكيد.",
        deleteFinal: "حذف نهائي",
        deleted: "تم حذف حسابك.",
        saved: "تم الحفظ."
    },
    contact: {
        eyebrow: "نحن هنا من أجلك",
        title: "اتصل بنا",
        intro: "راسلنا أو أرسل طلب حجز مباشرة، وسنتواصل معك شخصياً في أقرب وقت ممكن.",
        email: "البريد الإلكتروني",
        address: "العنوان",
        phone: "الهاتف",
        whatsapp: "واتساب",
        mapLink: "فتح في خرائط Google",
        bookingTitle: "اطلب إقامتك",
        bookingText: "أسرع طريق إلى مكان إقامتك: أرسل إلينا تواريخ السفر ورغباتك عبر نموذج الطلب.",
        bookingButton: "إلى طلب الحجز",
        accountTitle: "هل أنت عميل لدينا؟",
        accountText: "راسلنا مباشرة من حسابك، لتبقى المحادثة كاملة أمامك دائماً.",
        accountButton: "كتابة رسالة",
        faqTitle: "الأسئلة الشائعة",
        faq: [
            { question: "هل طلبي ملزم؟", answer: "لا. طلبك مجاني وغير ملزم، ولا يصبح ملزماً إلا بعد أن نؤكد حجزك." },
            { question: "هل أحتاج إلى حساب؟", answer: "لا، يمكنك إرسال طلب بدون حساب أيضاً. لكن مع الحساب يمكنك رؤية حالة طلباتك وحجوزاتك ورسائلك ومستنداتك في أي وقت." },
            { question: "كيف ألغي طلباً أو حجزاً؟", answer: "سجّل الدخول إلى حسابك وافتح الطلب أو الحجز، ويمكنك إلغاؤه من هناك. بدون حساب، أرسل إلينا ببساطة رسالة تتضمن رقم الحجز." },
            { question: "كيف أقدم شكوى؟", answer: "من خلال حسابك ضمن قسم «شكاواي». يمكنك إرفاق الصور والمستندات ومتابعة حالة المعالجة في أي وقت." }
        ]
    },
    footer: {
        about: "فيلات ومنازل وشقق لقضاء العطلات في جرجيس وجربة، برعاية شخصية من المؤنسة.",
        explore: "اكتشف",
        service: "الخدمات",
        contact: "اتصل بنا",
        privacy: "الخصوصية",
        imprint: "البيانات القانونية",
        rights: "جميع الحقوق محفوظة."
    },
    legal: {
        privacyTitle: "سياسة الخصوصية",
        privacyUpdated: "آخر تحديث: نوفمبر 2026",
        privacy: [
            { heading: "الجهة المسؤولة", body: "الجهة المسؤولة عن معالجة بياناتك على هذا الموقع هي URLAUB DE LUXE TUNESIEN، المؤنسة، 4144 جرجيس، تونس. يمكنك التواصل معنا عبر البريد الإلكتروني urlaub.de.luxe.info@gmail.com." },
            { heading: "البيانات التي نعالجها", body: "عند إنشاء حساب نحفظ الاسم الأول واسم العائلة والبريد الإلكتروني ورقم الهاتف والجنسية. نحفظ كلمة المرور فقط على شكل بصمة آمنة لا يمكن عكسها. وفي طلبات الحجز نعالج أيضاً الوجهة ومكان الإقامة وتواريخ السفر وعدد الأشخاص ورغباتك ورسائلك. وفي الشكاوى نحفظ وصفك والصور والمستندات التي ترفعها." },
            { heading: "الأغراض والأسس القانونية", body: "نعالج بياناتك للرد على الطلبات وتنفيذ الحجوزات وتوفير حسابك ومعالجة الشكاوى (المادة 6، الفقرة 1، البند ب من اللائحة العامة لحماية البيانات). لا نرسل العروض عبر البريد الإلكتروني إلا بموافقتك الصريحة (المادة 6، الفقرة 1، البند أ)، ويمكنك سحبها في أي وقت من حسابك. وللحماية من إساءة الاستخدام نعالج بيانات تقنية مثل معرّف IP مستعار (المادة 6، الفقرة 1، البند و)." },
            { heading: "الرسائل الإلكترونية", body: "نرسل التأكيدات والرسائل عبر خدمة البريد الإلكتروني لدى مزود موقعنا. في رسائل HTML يتم تسجيل ما إذا تم فتح الرسالة والروابط التي تم النقر عليها، ونستخدم هذه المعلومات فقط لضمان وصول رسائلنا. ويتم حظر العناوين التي يتعذر إيصال الرسائل إليها بشكل دائم تلقائياً." },
            { heading: "ملفات تعريف الارتباط وإحصاءات الزيارات", body: "نستخدم ملف تعريف ارتباط واحداً ضرورياً تقنياً لإبقائك مسجلاً للدخول، ولا نستخدم ملفات تعريف ارتباط إعلانية أو للتتبع. ولإحصاءات الزيارات نستخدم طريقة بدون ملفات تعريف ارتباط لا تنشئ أي ملفات شخصية." },
            { heading: "مكان الحفظ ومدته", body: "تُحفظ بياناتك لدى مزود الاستضافة لدينا، والملفات في مساحة تخزين محمية وغير عامة. نحتفظ ببياناتك طالما بقي حسابك قائماً أو اقتضت ذلك التزامات قانونية. وعند حذف حسابك تُحذف بياناتك الشخصية وشكاواك ورسائلك ومستنداتك وتصبح بيانات الحجز مجهولة الهوية." },
            { heading: "حقوقك", body: "يحق لك الاطلاع على بياناتك وتصحيحها وحذفها وتقييد معالجتها ونقلها والاعتراض عليها، كما يحق لك سحب أي موافقة في أي وقت. يمكنك حذف حسابك بنفسك في أي وقت من قسم «إعداداتي». ويمكنك أيضاً تقديم شكوى إلى سلطة رقابية لحماية البيانات." },
            { heading: "التواصل بشأن حماية البيانات", body: "لأي أسئلة تتعلق بحماية البيانات راسلنا على urlaub.de.luxe.info@gmail.com." }
        ],
        imprintTitle: "البيانات القانونية",
        imprintProvider: "مقدم الخدمة",
        imprintRepresented: "يمثلها",
        imprintContact: "التواصل",
        imprintEmail: "البريد الإلكتروني",
        imprintPhone: "الهاتف",
        imprintResponsible: "المسؤول عن المحتوى",
        imprintDisclaimerTitle: "المسؤولية عن المحتوى",
        imprintDisclaimer: "تم إعداد محتوى هذا الموقع بأقصى درجات العناية، إلا أننا لا نضمن صحة المحتوى واكتماله وحداثته. تعد البيانات الواردة في تأكيد الحجز المكتوب الصادر عنا هي الوحيدة الملزمة."
    },
    notFound: {
        title: "الصفحة غير موجودة",
        text: "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
        button: "إلى الصفحة الرئيسية"
    }
}
